import { useQuery } from "@apollo/client/react";

import { DdiHomeFilterInputFilterType } from '../components';
import { DDI_HOME_REPORT_SUMMARY } from '../graphql';

interface UseDdiHomeReportSummaryProps {
  filters: DdiHomeFilterInputFilterType;
  skip: boolean;
}

export const useDdiHomeReportSummary = ({ filters, skip }: UseDdiHomeReportSummaryProps) => {
  const { metric: _metric, ...filterInput } = filters;
  const { data, loading, error, refetch } = useQuery(DDI_HOME_REPORT_SUMMARY, {
    variables: {
      input: filterInput,
    },
    skip,
  });

  return {
    reportSummary: data?.ddiHomeReportSummary,
    loading,
    error,
    refetch,
  };
};
